'use client';

import { mdiTools } from '@mdi/js';
import Icon from '@mdi/react';

type Maintenance = {
  id: string;
  title: string;
  description: string;
  startAt: string;
  endAt: string;
  status: string;
};

interface MaintenanceScreenProps {
  maintenance: Maintenance;
}

export default function MaintenanceScreen({ maintenance }: MaintenanceScreenProps) {
  const formatTimestamp = (timestamp: string) => {
    const date = new Date(parseInt(timestamp) * 1000);
    return date.toLocaleString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-lg">
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-orange-100 p-4">
            <Icon path={mdiTools} size={3} className="text-orange-600" />
          </div>
        </div>

        <h1 className="mb-4 text-center text-2xl font-bold text-gray-900">メンテナンス中</h1>

        <div className="mb-6 space-y-4">
          <div>
            <h2 className="mb-2 text-lg font-semibold text-gray-800">{maintenance.title}</h2>
            <p className="whitespace-pre-wrap text-gray-600">{maintenance.description}</p>
          </div>

          <div className="rounded-md bg-gray-50 p-4">
            <div className="mb-2 flex items-center justify-between text-sm">
              <span className="text-gray-500">開始時刻:</span>
              <span className="font-medium text-gray-900">{formatTimestamp(maintenance.startAt)}</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-gray-500">終了予定:</span>
              <span className="font-medium text-gray-900">{formatTimestamp(maintenance.endAt)}</span>
            </div>
          </div>
        </div>

        <div className="rounded-md bg-blue-50 p-4 text-sm text-blue-800">
          <p className="font-medium">メンテナンス終了までお待ちください。</p>
          <p className="mt-1">自動的に通常画面に戻ります。</p>
        </div>
      </div>
    </div>
  );
}
